import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import Select from "react-select";
import moment from "moment";
import _ from "i18n";

import { Button, DatePicker, Tooltip } from "antd";
import { SettingIcon } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";

import styles from "./UpdateCollaboratorContent.local.scss";
import { getCountOpenDays, getDatesBetweenDates } from "../../utils";
import Switch from "../Common/Switch/Switch";
import { fetchUsers } from "thunks";

const daysOfWeek = ["monday", "tuesday", "wednesday", "thursday", "friday"];

class UpdateCollaboratorContent extends Component {
  // **** UpdateCollaboratorContent (functions) ***** //
  constructor(props) {
    super(props);
    let dates = getDatesBetweenDates(
      new Date(this.props.year + "-01-01"),
      new Date(this.props.year + "-12-31")
    );
    let countOpenDays = getCountOpenDays(dates);
    const {
      collaborator,
      collaborator: { workingHours }
    } = this.props;
    console.log("TEST", { props, collaborator });
    let hours = 0;
    collaborator.regimeSelected &&
      daysOfWeek.forEach(k => {
        hours +=
          Number(workingHours[k].split(".")[0]) * 60 +
          Number(workingHours[k].split(".")[1]);
      });
    const sumHours = Math.floor(hours / 60) + "." + (hours % 60);
    const hrForWeek =
      collaborator.regimeSelected && collaborator.regimeSelected.hrForWeek;
    const annualCalendar =
      this.props.settingSuggestions.data.annualCalendar[collaborator.year] &&
      this.props.settingSuggestions.data.annualCalendar[collaborator.year][0][
        collaborator.zone
      ]
        ? this.props.settingSuggestions.data.annualCalendar[
            collaborator.year
          ][0][collaborator.zone]
        : 0;

    this.state = {
      collaborator: collaborator,
      disabledSave: true,
      isOfficeWorkPlace: collaborator.isOfficeWorkPlace
        ? collaborator.isOfficeWorkPlace
        : {
            monday: 0,
            tuesday: 0,
            wednesday: 0,
            thursday: 0,
            friday: 0
          },
      active: null,
      saving: false,
      isFreelancer:
        collaborator.regimeSelected && collaborator.regimeSelected.isFreelancer,
      workingHours: collaborator.regimeSelected && collaborator.workingHours,
      sumHours: sumHours,
      countOpenDays: countOpenDays,
      daysOn:
        collaborator.regimeSelected && collaborator.regimeSelected.isFreelancer
          ? collaborator.openDays
          : 0,
      disabledWorkingHours:
        collaborator.regimeSelected &&
        collaborator.regimeSelected.label.includes("plein"),
      hrForWeek: hrForWeek,
      affectedHours: (hrForWeek - sumHours).toString().includes(".")
        ? hrForWeek - sumHours
        : hrForWeek - sumHours + ".0",
      nbrOfHolidays: annualCalendar !== 0 ? annualCalendar["nbrOfHolidays"] : 0,
      nbrOfAnnualHolidays:
        annualCalendar !== 0 ? annualCalendar["nbrOfAnnualHolidays"] : 0,
      nbrOfRecoveredAnnualHolidays:
        collaborator.nbrOfRecoveredAnnualHolidays != null
          ? collaborator.nbrOfRecoveredAnnualHolidays
          : 0
    };
  }

  componentDidMount() {
    this.props.dispatch(fetchUsers());
  }

  handleChangeSpecialProject = event => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        nfSpecialProject: event.target.value,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeArrivalDate = date => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        arrivalDate: date,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeDepartureDate = date => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        departureDate: date,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeWorkingHoursValue = (hourValue, i, minuteValue) => {
    let { hrForWeek } = this.state;
    let hoursOfDays = [];
    let sumHours = 0;
    daysOfWeek.forEach(k => {
      hoursOfDays[k] =
        (i === k) & (hourValue < 24) & (minuteValue < 60)
          ? hourValue + "." + minuteValue
          : this.state.collaborator.workingHours[k];
      sumHours +=
        Number(hoursOfDays[k].split(".")[0]) * 60 +
        Number(hoursOfDays[k].split(".")[1]);
    });
    sumHours = Math.floor(sumHours / 60) + "." + (sumHours % 60);
    let hours =
      Number((sumHours.split(".")[1] * 60) / 3600) +
      Number(sumHours.split(".")[0]);
    let daysOn = this.state.isFreelancer
      ? Math.round(parseInt(Number(hrForWeek) / Number(hours / 5), 10))
      : 0;
    this.setState(state => {
      return {
        sumHours: Math.floor(sumHours / 60) + "." + (sumHours % 60),
        workingHours: {
          monday: hoursOfDays["monday"],
          tuesday: hoursOfDays["tuesday"],
          wednesday: hoursOfDays["wednesday"],
          thursday: hoursOfDays["thursday"],
          friday: hoursOfDays["friday"]
        },
        daysOn: this.state.isFreelancer ? daysOn : 0,
        collaborator: {
          ...this.state.collaborator,
          openDays: this.state.isFreelancer ? daysOn : 0,
          workingHours: {
            monday: hoursOfDays["monday"],
            tuesday: hoursOfDays["tuesday"],
            wednesday: hoursOfDays["wednesday"],
            thursday: hoursOfDays["thursday"],
            friday: hoursOfDays["friday"]
          }
        }
      };
    });
    this.handleCalculateAffectedHours(
      hoursOfDays,
      this.state.hrForWeek,
      this.state.isFreelancer
    );
  };

  handleChangeZone = event => {
    const { collaborator } = this.state;
    const { settingSuggestions } = this.props;
    let annualCalendar =
      settingSuggestions.data.annualCalendar[collaborator.year] &&
      settingSuggestions.data.annualCalendar[collaborator.year][0][event.value]
        ? settingSuggestions.data.annualCalendar[collaborator.year][0][
            event.value
          ]
        : 0;
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      nbrOfHolidays: annualCalendar !== 0 ? annualCalendar["nbrOfHolidays"] : 0,
      nbrOfAnnualHolidays:
        annualCalendar !== 0 ? annualCalendar["nbrOfAnnualHolidays"] : 0,
      collaborator: {
        ...this.state.collaborator,
        zone: event.value,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeBu = event => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        bu: event.value,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeAdmin = event => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        admin: event.value
      }
    });
  };

  handleChangeRole = event => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        role: event.value,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeBackup = selectedOptions => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        backup: selectedOptions
          ? selectedOptions.map(option => option.value)
          : [],
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeRegime = event => {
    const { countOpenDays } = this.state;

    let hoursOfDays = [];
    daysOfWeek.forEach((k, index) => {
      if (event.hrForWeek === 44) {
        if (index < 4) {
          hoursOfDays[k] = parseInt(9) + "." + parseInt(0);
        } else if (index === 4) {
          hoursOfDays[k] = parseInt(8) + "." + parseInt(0);
        }
      } else {
        hoursOfDays[k] =
          parseInt(event.hrForWeek / 5, 10) +
          "." +
          Math.round(
            (event.hrForWeek / 5 - parseInt(event.hrForWeek / 5, 10)) * 60
          );
      }
    });
    this.setState({
      disabledWorkingHours: event.label.includes("plein"),
      isFreelancer: event.isFreelancer,
      hrForWeek: event.hrForWeek,
      workingHours: {
        monday: hoursOfDays["monday"],
        tuesday: hoursOfDays["tuesday"],
        wednesday: hoursOfDays["wednesday"],
        thursday: hoursOfDays["thursday"],
        friday: hoursOfDays["friday"]
      },
      daysOn: countOpenDays,
      collaborator: {
        ...this.state.collaborator,
        regime: event.value,
        openDays: event.isFreelancer ? countOpenDays : 0.0,
        workingHours: {
          monday: hoursOfDays["monday"],
          tuesday: hoursOfDays["tuesday"],
          wednesday: hoursOfDays["wednesday"],
          thursday: hoursOfDays["thursday"],
          friday: hoursOfDays["friday"]
        }
      },
      sumHours:
        Number(hoursOfDays["monday"]) +
        Number(hoursOfDays["tuesday"]) +
        Number(hoursOfDays["wednesday"]) +
        Number(hoursOfDays["thursday"]) +
        Number(hoursOfDays["friday"])
    });

    this.handleCalculateAffectedHours(
      hoursOfDays,
      event.hrForWeek,
      event.isFreelancer
    );
  };

  handleChangeProfile = event => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        profile: event.value,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangePartner = event => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        partner: event.value,
        workingHours: this.state.workingHours
      }
    });
  };

  handleChangeHolidayTypeValue = (value, holidayType) => {
    let list = this.state.collaborator.holidayTypes
      ? this.state.collaborator.holidayTypes
      : [];
    let found = false;

    if (list.length > 0) {
      list.forEach(item => {
        if (item.id === holidayType.id) {
          item.nbrOfDays = value;
          found = true;
          if (value === "") {
            item.nbrOfDays = value;
            list = list.filter(({ id }) => id !== holidayType.id);
            found = true;
          }
        }
      });
    }
    if (!found) {
      list.push({
        id: holidayType.id,
        label: holidayType.label,
        nbrOfDays: value
      });
    }
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        holidayTypes: list,
        workingHours: this.state.workingHours
      }
    });
  };

  handleUpdateCollaborator = () => {
    const { collaborator } = this.state;
    console.log({ state: this.state });
    this.setState({
      saving: true
    });
    this.props.onSave(collaborator);
  };

  handleCheckMaxLengthHours = event => {
    if (event.target.value.length > event.target.maxLength) {
      event.target.value = event.target.value.slice(0, event.target.maxLength);
    }
  };

  handleCalculateAffectedHours = (hoursOfDays, hrForWeek, isFreelancer) => {
    let sumHours = 0;
    let hours;

    daysOfWeek.forEach(k => {
      sumHours += Number(
        Number(hoursOfDays[k].split(".")[0]) * 60 +
          Number(hoursOfDays[k].split(".")[1])
      );
    });
    hours = Number(Math.floor(hrForWeek) * 60 - sumHours);

    this.setState({
      disabledSave: !isFreelancer ? hours !== 0 : false,
      affectedHours: Math.floor(hours / 60) + "." + (hours % 60)
    });
  };

  handleChangeWorkPlace = day => {
    this.setState(
      prevState => {
        let workPlaces = prevState.isOfficeWorkPlace;
        workPlaces = {
          ...workPlaces,
          [day]: workPlaces[day] === 0 ? 1 : 0
        };

        return {
          ...prevState,
          isOfficeWorkPlace: workPlaces,
          collaborator: {
            ...prevState.collaborator,
            isOfficeWorkPlace: workPlaces
          }
        };
      },
      () => {
        this.setState({
          disabledSave: this.state.isFreelancer
        });
      }
    );
  };

  handleChangeNbrOfRecoveredAnnualHolidays = value => {
    this.setState({
      disabledSave: !this.state.isFreelancer
        ? this.state.sumHours - this.state.hrForWeek !== 0
        : false,
      collaborator: {
        ...this.state.collaborator,
        nbrOfRecoveredAnnualHolidays: parseInt(value)
      },
      nbrOfRecoveredAnnualHolidays: value
    });
  };

  render() {
    const { settingSuggestions, collaborators, users } = this.props;
    const { collaborator } = this.state;
    const { isOfficeWorkPlace } = this.state;
    const holidayTypes = settingSuggestions.data.holidayTypes.filter(it => {
      return it.zone === collaborator.zone;
    });

    let regimeOptions =
      settingSuggestions.data.regimes &&
      settingSuggestions.data.regimes.map(regime => {
        return {
          label: regime.label,
          value: regime.id,
          isFreelancer: regime.isFreelancer,
          hrForWeek: regime.hrForWeek
        };
      });

    let roleOptions =
      settingSuggestions.data.roles &&
      settingSuggestions.data.roles.map(role => {
        return {
          label: _(role.label === "manager" ? "folderManager" : role.label),
          value: role.id
        };
      });

    let collaboratorOptions =
      collaborators &&
      collaborators.map(collaborator => {
        return {
          label: _(collaborator.name),
          value: collaborator.id
        };
      });

    let zoneOptions =
      settingSuggestions.data.zones &&
      settingSuggestions.data.zones.map(zone => {
        return { label: zone.label, value: zone.id };
      });

    let buOptions =
      settingSuggestions.data.bus &&
      settingSuggestions.data.bus.map(bu => {
        return { label: bu.label, value: bu.id };
      });

    let profileOptions = [
      { label: "Senior", value: "SENIOR" },
      { label: "Medior", value: "MEDIOR" },
      { label: "Junior", value: "JUNIOR" },
      { label: "Admin", value: "ADMIN" }
    ];

    let partnerOptions =
      users &&
      users
        .filter(u => u.accountingAuthorization.role == "MANAGER")
        .map(user => {
          return {
            label: `${user.firstName} ${user.lastName}`,
            value: user.id
          };
        });
    partnerOptions = [{ label: "None", value: null }, ...partnerOptions];

    return (
      <div className="tamtam-modal upload-modal upload-modal__body">
        <ModalCloseButton onClose={this.props.onCancel} />
        <div className="upload-modal__content">
          <div className="upload-modal__header small-12">
            <div className="upload-modal__header-icon">
              <SettingIcon fill="#2495E1" size="20" />
            </div>
            <div className="upload-modal__header-title">
              {_("UpdateCollaboratorSettingTitle")}
            </div>
          </div>
          <div className={styles.modal_content}>
            <h2>
              {_("ProfilCollaboratorSetting")} : {collaborator.collaboratorName}
              {collaborator.erpId ? (
                <Tooltip
                  placement="right"
                  title={
                    <div>
                      <p>
                        {_("importedFrom")} : {collaborator.erpLabel}
                      </p>
                      <p>
                        {_("identifier")} : {collaborator.erpId}
                      </p>
                    </div>
                  }
                >
                  {" "}
                  <img
                    src="/img/icons/info.svg"
                    alt="text"
                    className={styles.img_info}
                  />{" "}
                </Tooltip>
              ) : (
                ""
              )}
            </h2>
            <div className={classnames("row", styles.form_group)}>
              <div className="medium-4 small-4">
                <div className={styles.input_div}>
                  <span>{_("arrivalDate")}</span>
                  <div className={styles.date_input}>
                    <DatePicker
                      allowClear={true}
                      placeholder={_("selectDate")}
                      onChange={this.handleChangeArrivalDate}
                      value={
                        collaborator.arrivalDate
                          ? moment(
                              collaborator.arrivalDate,
                              "YYYY-MM-DD hh:mm:ss"
                            )
                          : null
                      }
                    />
                  </div>
                </div>
                <div className={styles.input_div}>
                  <span>{_("departureDate")}</span>
                  <div className={styles.date_input}>
                    <DatePicker
                      allowClear={true}
                      placeholder={_("selectDate")}
                      onChange={this.handleChangeDepartureDate}
                      value={
                        collaborator.departureDate
                          ? moment(
                              collaborator.departureDate,
                              "YYYY-MM-DD hh:mm:ss"
                            )
                          : null
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="medium-4 small-4">
                <div className={styles.input_div}>
                  <span>{_("zone")}</span>
                  <Select
                    value={
                      zoneOptions &&
                      zoneOptions.find(
                        obj => obj.value === this.state.collaborator.zone
                      )
                    }
                    onChange={this.handleChangeZone}
                    options={zoneOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectZone")}
                    menuPlacement="auto"
                  />
                </div>
                <div className={styles.input_div}>
                  <span>{_("bu")}</span>
                  <Select
                    value={
                      buOptions &&
                      buOptions.find(
                        obj => obj.value === this.state.collaborator.bu
                      )
                    }
                    onChange={event => this.handleChangeBu(event)}
                    options={buOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectBu")}
                    menuPlacement="auto"
                  />
                </div>
              </div>
              <div className="medium-4 small-4">
                <div className={styles.input_div}>
                  <span>{_("role")}</span>
                  <Select
                    value={
                      roleOptions &&
                      roleOptions.find(
                        obj => obj.value === this.state.collaborator.role
                      )
                    }
                    onChange={event => this.handleChangeRole(event)}
                    options={roleOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectRole")}
                    menuPlacement="auto"
                  />
                </div>
                <div className={styles.input_div}>
                  <span>{_("backup")}</span>
                  <Select
                    isMulti={true}
                    value={
                      collaboratorOptions &&
                      this.state.collaborator.backup &&
                      collaboratorOptions.filter(obj =>
                        this.state.collaborator.backup.includes(obj.value)
                      )
                    }
                    onChange={event => this.handleChangeBackup(event)}
                    options={collaboratorOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    style={{ height: "80px" }}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectRole")}
                    menuPlacement="auto"
                  />
                </div>
              </div>
              <div className="medium-4 small-4">
                <div className={styles.input_div}>
                  <span>{_("grade")}</span>
                  <Select
                    value={
                      profileOptions &&
                      profileOptions.find(
                        obj => obj.value === this.state.collaborator.profile
                      )
                    }
                    onChange={this.handleChangeProfile}
                    options={profileOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectProfile")}
                    menuPlacement="auto"
                  />
                </div>
              </div>
              <div className="medium-4 small-4">
                <div className={styles.input_div}>
                  <span>{_("partner")}</span>
                  <Select
                    value={
                      partnerOptions &&
                      partnerOptions.find(
                        obj => obj.value === this.state.collaborator.partner
                      )
                    }
                    isClearable={true}
                    onChange={this.handleChangePartner}
                    options={partnerOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectPartner")}
                    menuPlacement="auto"
                  />
                </div>
              </div>
              <div className="medium-4 small-4">
                <div className={styles.input_div}>
                  <span>{_("admin")}</span>
                  <Select
                    isMulti={false}
                    value={
                      collaboratorOptions &&
                      collaboratorOptions.find(
                        obj => obj.value === this.state.collaborator.admin
                      )
                    }
                    isClearable={true}
                    onChange={event => this.handleChangeAdmin(event)}
                    options={collaboratorOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    style={{ height: "80px" }}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectCollaborator")}
                    menuPlacement="auto"
                  />
                </div>
              </div>
            </div>
            <div className={classnames("row", styles.form_group)}>
              <div className={"medium-3 small-3"}>
                <div className={styles.input_div}>
                  <span>{_("regime")}</span>
                  <Select
                    value={
                      regimeOptions &&
                      regimeOptions.find(
                        obj => obj.value === this.state.collaborator.regime
                      )
                    }
                    onChange={event => this.handleChangeRegime(event)}
                    options={regimeOptions}
                    className={classnames(
                      "select_large",
                      "select-width-12",
                      "created"
                    )}
                    classNamePrefix="ttp-select"
                    placeholder={_("selectRegime")}
                    menuPlacement="auto"
                  />
                </div>
              </div>
              <div className={"medium-3 small-3"}>
                <div className={styles.input_div}>
                  <span>{_("specialProject")}</span>
                  <input
                    type={"number"}
                    placeholder={_("enterSpecialProject")}
                    value={
                      collaborator.nfSpecialProject
                        ? collaborator.nfSpecialProject
                        : ""
                    }
                    onChange={this.handleChangeSpecialProject}
                  />
                </div>
              </div>
            </div>

            <div>
              <span
                className={classnames("row", styles.labels)}
                style={{ textTransform: "none" }}
              >
                {_("WorkingHoursPerDay")}
                {!this.state.isFreelancer ? (
                  collaborator.regime ? (
                    this.state.affectedHours.split(".")[0] < 0 ||
                    this.state.affectedHours.split(".")[1] < 0 ? (
                      <div className={styles.overtakingHours}>
                        (
                        {_("OvertakingHours")}
                        {Math.abs(
                          (this.state.affectedHours.split(".")[1] < 0
                            ? -1
                            : 0) - this.state.affectedHours.split(".")[0]
                        ) +
                          "h" +
                          (Math.abs(this.state.affectedHours.split(".")[1]) < 10
                            ? "0" +
                              Math.abs(this.state.affectedHours.split(".")[1])
                            : Math.abs(this.state.affectedHours.split(".")[1]))}
                        )
                      </div>
                    ) : (
                      <div>
                        {"("}
                        {_("TimeLeft")}
                        {this.state.sumHours - this.state.hrForWeek === 0
                          ? "0H00"
                          : Math.abs(this.state.affectedHours.split(".")[0]) +
                            "h" +
                            (Math.abs(this.state.affectedHours.split(".")[1]) <
                            10
                              ? "0" +
                                Math.abs(this.state.affectedHours.split(".")[1])
                              : Math.abs(
                                  this.state.affectedHours.split(".")[1]
                                ))}
                        {")"}
                      </div>
                    )
                  ) : (
                    <div className={styles.overtakingHours}>
                      {_("selectRegimeMessage")}
                    </div>
                  )
                ) : (
                  <div style={{ display: "flex" }}>
                    {" pour un objectif  de : " +
                      this.state.hrForWeek +
                      " h/semaine"}
                    {" sur une base de : " +
                      this.state.daysOn +
                      " jours ouvrables"}
                    {this.state.daysOn - this.state.countOpenDays > 0 ? (
                      <div
                        className={styles.overtakingHours}
                        style={{ position: "relative" }}
                      >
                        {_("Attention vous avez un dépassement de ")}
                        {this.state.daysOn - this.state.countOpenDays}
                        {_(" jours")}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </span>

              <div
                className={classnames("row", styles.form_group)}
                style={{
                  display: "flex",
                  textAlign: "center",
                  justifyContent: "center",
                  paddingBottom: 12,
                  gap: "32px"
                }}
              >
                {daysOfWeek &&
                  daysOfWeek.map((i, key) => (
                    <div
                      key={key}
                      className={"medium-2 small-2"}
                      style={{ marginRight: " 5px" }}
                    >
                      <div className={styles.labels}>{_(i)}</div>
                      <div
                        className={styles.input_div}
                        style={{
                          padding: "0px"
                        }}
                      >
                        <div className={styles.block}>
                          <div
                            className={styles.hours_content}
                            style={{
                              width: "100%",
                              justifyContent: "center",

                              background:
                                this.state.disabledWorkingHours ||
                                collaborator.regime === null
                                  ? "#e6e6e6"
                                  : "#f8f9fa"
                            }}
                          >
                            <input
                              type={"number"}
                              min={"0"}
                              max={"24"}
                              placeholder={"0"}
                              maxLength={2}
                              onInput={this.handleCheckMaxLengthHours}
                              value={
                                collaborator.regime &&
                                this.state.workingHours[i]
                                  ? this.state.workingHours[i].split(".")[0]
                                  : 0
                              }
                              onChange={event =>
                                this.handleChangeWorkingHoursValue(
                                  event.target.value,
                                  i,
                                  this.state.workingHours[i].split(".")[1]
                                )
                              }
                              disabled={
                                this.state.disabledWorkingHours ||
                                collaborator.regime === null
                              }
                            />{" "}
                            H
                            <input
                              type={"number"}
                              min={"0"}
                              max={"59"}
                              placeholder={"00"}
                              maxLength={2}
                              onInput={this.handleCheckMaxLengthHours}
                              value={
                                collaborator.regime &&
                                this.state.workingHours[i] &&
                                this.state.workingHours[i].split(".")[1]
                                  ? this.state.workingHours[i].split(".")[1]
                                  : ""
                              }
                              onChange={event =>
                                this.handleChangeWorkingHoursValue(
                                  this.state.workingHours[i].split(".")[0],
                                  i,
                                  event.target.value
                                )
                              }
                              disabled={
                                this.state.disabledWorkingHours ||
                                collaborator.regime === null
                              }
                            />
                          </div>
                          <div
                            key={key}
                            className={classnames(
                              styles.group_info,
                              styles.place_work_content,
                              this.state.active === key && styles.selected_info
                            )}
                            style={{
                              display: "flex",
                              justifyContent: "space-between"
                            }}
                            onClick={() => this.handleChangeWorkPlace(i)}
                          >
                            <span className={styles.label}>Bureau</span>
                            <Switch
                              name={i}
                              isChecked={
                                isOfficeWorkPlace && isOfficeWorkPlace[i] === 1
                              }
                              onChange={() => this.handleChangeWorkPlace(i)}
                            />
                            <span className={styles.label}>Télétravail</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className={classnames("row", styles.form_group)}>
              {holidayTypes &&
                holidayTypes.map(holidayType => {
                  return (
                    holidayType.isVoluntary &&
                    holidayType.id !== 2 &&
                    (holidayType.abbreviation !== "CA" ? (
                      <div key={holidayType.id} className={"medium-3 small-3"}>
                        <div className={styles.input_div}>
                          <span>
                            {holidayType.label.slice(0, 25) +
                              (holidayType.label.length > 25 ? "..." : "")}
                          </span>
                          <input
                            type={"number"}
                            placeholder={_("NumberOfDays")}
                            value={
                              collaborator.holidayTypes.find(
                                obj => obj.id === holidayType.id
                              )
                                ? collaborator.holidayTypes.find(
                                    obj => obj.id === holidayType.id
                                  ).nbrOfDays
                                : ""
                            }
                            onChange={event =>
                              this.handleChangeHolidayTypeValue(
                                event.target.value,
                                holidayType
                              )
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <div className={styles.input_div}>
                        <span>
                          {holidayType.label.slice(0, 25) +
                            (holidayType.label.length > 25 ? "..." : "")}
                        </span>
                        <input
                          type={"number"}
                          style={{
                            textAlign: "center",
                            appearance: "textfield",
                            backgroundColor: "#f8f9fa"
                          }}
                          value={
                            collaborator.bu === 4 || collaborator.bu === 5
                              ? collaborator.arrivalDate
                                ? Math.floor(
                                    (new Date().getFullYear() -
                                      new Date(
                                        collaborator.arrivalDate
                                      ).getFullYear()) /
                                      5
                                  )
                                : 0
                              : 0
                          }
                          readOnly={true}
                        />
                      </div>
                    ))
                  );
                })}
              {collaborator.zone === 2 && (
                <div className={"medium-3 small-3"}>
                  <div className={styles.input_div}>
                    <span>Congé Récupération annuel</span>
                    <input
                      type={"number"}
                      placeholder={_("NumberOfDays")}
                      style={{
                        textAlign: "left",
                        appearance: "textfield",
                        backgroundColor: "#f8f9fa"
                      }}
                      value={this.state.nbrOfRecoveredAnnualHolidays}
                      onChange={event =>
                        this.handleChangeNbrOfRecoveredAnnualHolidays(
                          event.target.value
                        )
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            <div className={classnames("row")}>
              <div className={styles.input_div}>
                <span>
                  {_("Congé fixe - RTT")} : {this.state.nbrOfAnnualHolidays}j
                </span>
                <span>
                  {_("holidays")} : {this.state.nbrOfHolidays}j
                </span>
              </div>
            </div>
          </div>
          <div className={styles.modal_footer}>
            <button
              type={"success"}
              className={styles.save_button}
              onClick={() => this.handleUpdateCollaborator()}
              disabled={this.state.disabledSave}
            >
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={this.props.saving ? styles.loading : ""}
              />
              {_("save")}
            </button>
            <Button
              type={"success"}
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: 14,
                height: 37,
                margin: "1px 3px 0px",
                background: "transparent",
                float: "left",
                textTransform: "uppercase",
                color: "#6D7F92"
              }}
              onClick={this.props.onCancel}
            >
              {_("cancel")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settingSuggestions: state.collaborator.settingSuggestions,
  users: state.authorizations.items
});

export default connect(mapStateToProps)(UpdateCollaboratorContent);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/UpdateCollaboratorContent.js